import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-369">
      <div className="max-w-4xl mx-auto text-center" data-id="element-370">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#00C853]/50 text-[#00C853] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-371">
          🏆 Sistema N°1 para Docentes de Italiano en Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-372">
          🇮🇹 PROFEPACK™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#00C853] mb-6" data-id="element-373">
          MEGAPACK ITALIANO LISTO
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-374">
          <strong data-id="element-375">6 Tomos + 6 Bonos — A1 → C1/C2 — Todo resuelto.</strong>
          <br data-id="element-376" />
          420+ páginas de contenido curricular completo. Solucionario en cada
          tomo. Planificación anual lista para presentar. Listo para usar desde
          hoy.
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-377">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-378">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['A1', 'A2', 'B1', 'B2', 'C1/C2', 'Kit Eval.'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
              backgroundColor: color,
              border: '2px solid #00C853'
            }} data-id="element-379">
                  <span className="text-white text-xs font-bold" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-380">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#00C853] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-381">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-382">
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-383">
            ✅ Por nivel (A1 → C1/C2 — Marco Común Europeo)
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-384">
            ✅ Con planificación anual lista
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-385">
            ✅ Con solucionario completo
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-386">
            ✅ Con evaluaciones y rúbricas
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-387">
            ✅ Con bonos incluidos
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-388">
            ✅ Con conexión cultural Italia-Argentina
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-389">
            ✅ Con errores de interferencia español-italiano integrados
          </span>
          <span className="bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-390">
            ✅ 100% alineado al Marco Común Europeo de Referencia (MCER)
          </span>
        </div>
      </div>
    </section>;
}